import L from 'leaflet';
import PropTypes from 'prop-types';
import {
  useEffect,
  useState,
} from 'react';

import { displayJson, logError } from '../../utils';
import {
  LeafletCircleMarker,
  LeafletMarker,
} from '../leaflet';

const circleMarkerRadiusPx = 8;
const dropPinMarginRatio = 4 / 46;
const iconMarginRatio = 1 / 46;
const plusMarkerSizePx = 12;

// const dropPinIcon = new L.Icon({
//   iconUrl: blank,
//   iconRetinaUrl: blank,
//   iconAnchor: [dropPinWidthPx / 2, dropPinHeightPx],
//   // popupAnchor: [10, -44],
//   iconSize: [dropPinWidthPx, dropPinHeightPx],
//   // iconRetinaUrl: require('../img/marker-pin-person.svg'),
//   // iconAnchor: null,
//   // popupAnchor: null,
//   shadowUrl: null,
//   shadowSize: null,
//   shadowAnchor: null,
//   // iconSize: new L.Point(60, 75),
//   // className: 'leaflet-div-icon',
// });

function PxMapMarkersOverlay(props) {
  const {
    allReady = false,
    mapStateDispatch,
    mapEvent,
    markersPending,
    markersArrayRef = {
      current: [],
    },
  } = props;
  const [markers, setMarkers] = useState(null);

  //
  // Create Marker container
  //
  useEffect(
    () => {
      mapStateDispatch({ type: 'setMarkersContainerReady', ready: true });

      // Cleanup
      return () => {
      // console.log('Destroy markers container');
        mapStateDispatch({ type: 'setMarkersContainerReady', ready: false });
      };
    },
    [mapStateDispatch],
  );

  // const forceOverlayRefresh = useCallback(
  //   () => {
  //     console.log('PxMap forceOverlayRefresh');
  //   },
  //   [],
  // );

  //
  // Redraw Overlay when needed
  //
  useEffect(
    () => {
    // console.log(`PxMap markersPending=${markersPending}`);
      if (allReady && (!markersPending)) {
      // forceOverlayRefresh();
      // console.log(`markersArrayRef.current.length=${
      //   markersArrayRef.current.length}, #0=${displayJson(markersArrayRef.current[0])}, #1=${
      //   displayJson(markersArrayRef.current[1])}`);
      // markersArrayRef.current.length=1, #0={
      //   "id": "qpI3W)jjvrTpj21jbThw",
      //   "title": "Case #qpI3W)jjvrTpj21jbThw",
      //   "type": "cases",
      //   "code": "police",
      //   "dropPin": true,
      //   "lat": 50.62264658608929,
      //   "lng": 3.025827371797289,
      //   "anchor": {
      //     "x": 0.5,
      //     "y": 1,
      //   },
      //   "opacity": 0.7,
      //   "sizePx": 50,
      //   "color": 16711680,
      //   "zIndex": 404180,
      // },
        if (markersArrayRef.current && markersArrayRef.current.length) {
          const newMarkers = markersArrayRef.current.map((thisMarker) => {
            const {
              id, lat, lng, circle, zIndex, opacity, colorHex, dropPin,
              type, code, heightPx, widthPx, plus, anchor, // color,
            } = thisMarker;

            if (!id) {
              logError(
                `PxMapMarkersOverlay marker=${displayJson(thisMarker)}`,
                'PxMapMarkersOverlay.missingMarkerId',
                {
                  type: thisMarker?.type,
                  code: thisMarker?.code,
                  markerKeys: thisMarker && Object.keys(thisMarker),
                },
              );
            }

            if (circle) {
              return (
                <LeafletCircleMarker
                  key={id}
                  center={{ lat, lng }}
                  radius={circleMarkerRadiusPx}
                  zIndexOffset={zIndex}
                  pathOptions={{
                  // https://leafletjs.com/reference-1.7.1.html#path
                  // fillColor: color,
                  // borderWidth: 1,
                  // color: 0x0,
                    stroke: true,
                    color: '#FFFFFF',
                    weight: 1.5,
                    opacity: 1,
                    fill: true,
                    fillColor: colorHex,
                    fillOpacity: 1,
                  }}
                  eventHandlers={{
                    click: (event) => {
                    // console.log(`marker clicked event=${displayJson(event, 2)} thisMarker=${
                    //   displayJson(thisMarker, 2)}`);
                    // console.log(`marker clicked event.target=${
                    //   displayJson(event.target, 2)} thisMarker=${
                    //   displayJson(thisMarker, 2)}`);
                      mapEvent({
                        event: 'click',
                        type,
                        code,
                        id,
                        coordinates: event.containerPoint,
                        position: { lat, lng },
                      });
                    },
                    mouseover: (event) => {
                    // console.log('marker mouseover');
                      mapEvent({
                        event: 'hover',
                        type,
                        code,
                        id,
                        coordinates: event.containerPoint,
                      });
                    },
                    mouseout: () => {
                    // console.log('marker mouseout');
                      mapEvent({
                        event: 'leave',
                        type,
                        code,
                        id,
                      });
                    },
                  }}
                />
              );
            }

            let thisIcon;
            let html;
            if (plus) {
              const divStyle = `position: relative; width: ${plusMarkerSizePx}px; height: ${
                plusMarkerSizePx}px;`;
              const svgStyle = 'position: absolute; width: 100%; height: 100%;';
              html = `<div style='${divStyle}'>`
                  + `<img style='${svgStyle}' src='/images/svg/maps/plusOutline.svg' />`
                  + `<img style='${svgStyle}' src='/images/svg/maps/plusInside.svg' />`
                  + '</div>';

              thisIcon = L.divIcon({
              // className: 'my-custom-pin',
                iconAnchor: [plusMarkerSizePx / 2, plusMarkerSizePx / 2],
                html,
              });

              return (
                <LeafletMarker
                  key={id}
                  position={{ lat, lng }}
                  opacity={opacity}
                  zIndexOffset={zIndex}
                  icon={thisIcon}
                // style={{
                //   background: '#00000000',
                //   border: '0px',
                // }}
                />
              );
            }

            // const style = `filter: invert(0.5) sepia(100%) hue-rotate(${
            //  colorHue - 30}deg) brightness();`;
            // const style = 'fill: blue;';
            // width: ${dropPinWidthPx}px;
            // height: ${dropPinHeightPx}px;
            // `;
            // 46, 30

            if (dropPin) {
              const divStyle = `position: relative; width: ${widthPx}px; height: ${heightPx}px;`;

              const pinStyle = `width: ${widthPx}px; height: ${heightPx
              }px; mask-size: cover; -webkit-mask-size: cover; background: ${colorHex
              }; mask-image: url("/images/svg/maps/blank.svg"); -webkit-mask-image: url("/images/svg/maps/blank.svg");`;

              const circleDivStyle = `position: absolute; top:0; left: 0; width: ${widthPx}px; height: ${
                widthPx}px; padding: ${dropPinMarginRatio * widthPx}px;`;

              const circleDivStyle2 = `position: relative; height: 100%; width: 100%; padding: ${
                iconMarginRatio * widthPx}px; background-color: white; border-radius: 50%; overflow: hidden;`;

              const iconStyle = 'width: 100%; height: 100%;';

              html = `<div style='${divStyle}'>`
                 + `<div style='${pinStyle}'>`
                 + `<div style='${circleDivStyle}'>`
                 + `<div style='${circleDivStyle2}'>`
                 + `<img style='${iconStyle}' src='/images/svg/${type}/${code}.svg' />`
                 + '</div>'
                 + '</div>'
                 + '</div>'
                 + '</div>';

              thisIcon = L.divIcon({
                className: '',
                iconSize: [widthPx, heightPx],
                iconAnchor: [widthPx * anchor.x, heightPx * anchor.y],
                html,
              });
            } else {
              const divStyle = `position: relative; overflow: hidden; width: ${widthPx}px; height: ${heightPx}px;`;

              const style = `width: ${widthPx}px; height: ${heightPx
              }px; mask-size: cover; -webkit-mask-size: cover; background: ${colorHex
              }; mask-image: url("/images/svg/${type}/${code
              }.svg"); -webkit-mask-image: url("/images/svg/${type}/${code}.svg");`;

              html = `<div style='${divStyle}'>`
                 + `<div style='${style}'/>`
                 + '</div>';

              thisIcon = L.divIcon({
                className: '',
                iconSize: [widthPx, heightPx],
                iconAnchor: [widthPx * anchor.x, heightPx * anchor.y],
                html,
              });
            }

            // console.log(`html=${html}`);

            return (
              <LeafletMarker
                key={id}
                position={{ lat, lng }}
                opacity={opacity}
                zIndexOffset={zIndex}
                icon={thisIcon}
                // style={{
                //   background: '#00000000',
                //   border: '0px',
                // }}
                eventHandlers={{
                  click: (event) => {
                  // console.log(`marker clicked event=${displayJson(event, 2)} thisMarker=${
                  //   displayJson(thisMarker, 2)}`);
                  // console.log(`marker clicked event.target=${
                  //   displayJson(event.target, 2)} thisMarker=${
                  //   displayJson(thisMarker, 2)}`);
                    mapEvent({
                      event: 'click',
                      type,
                      code,
                      id,
                      coordinates: event.containerPoint,
                      position: { lat, lng },
                    });
                  },
                  mouseover: (event) => {
                  // console.log('marker mouseover');
                    mapEvent({
                      event: 'hover',
                      type,
                      code,
                      id,
                      coordinates: event.containerPoint,
                    });
                  },
                  mouseout: () => {
                  // console.log('marker mouseout');
                    mapEvent({
                      event: 'leave',
                      type,
                      code,
                      id,
                    });
                  },
                }}
              />
            );

          // return (
          //   <>
          //     <Marker
          //       position={{ lat, lng }}
          //       opacity={opacity}
          //       // opacity={0.1}
          //       zIndexOffset={zIndex}
          //       icon={dropPinIcon}
          //       pathOptions={{
          //       // https://leafletjs.com/reference-1.7.1.html#path
          //         // stroke: false,
          //         fill: true,
          //         // fillColor: `#${color.toString(16)}`,
          //         fillColor: '#FF0000',
          //         fillOpacity: 1,
          //       }}
          //       style={{
          //         fill: 'red',
          //         backgroundColor: 'red',
          //       }}
          //     />
          //   </>
          // );
          });

          // console.log(`And newMarkers.length=${newMarkers.length}`);
          // if (newMarkers.length) {
          //   // eslint-disable-next-line no-debugger
          //   debugger;
          // }

          setMarkers(newMarkers);
        } else setMarkers(null);
      }
    },
    [allReady, markersPending, markersArrayRef, mapEvent],
  );

  // if (markers && markers.length) return markers[1];pPin": true,
  // "lat": 50.62268312504535,
  // "lng": 3.02608305774998,
  // "anchor": {
  //   "x": 0.5,
  //   "y": 1,
  // },
  // "opacity": 0.7,
  // "sizePx": 75,

  // const circle = (
  //   <Circle
  //     center={{
  //       lat: 50.62268312504535,
  //       lng: 3.02608305774998,
  //     }}
  //     opacity={1}
  //     radius={80}
  //     zIndex={3000000}
  //   />
  // );
  return (markers);
}

PxMapMarkersOverlay.propTypes = {
  allReady: PropTypes.bool,
  mapStateDispatch: PropTypes.func.isRequired,
  mapEvent: PropTypes.func.isRequired,
  markersPending: PropTypes.bool.isRequired,
  markersArrayRef: (PropTypes.shape({
    current: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        type: PropTypes.string,
        code: PropTypes.string,
        lat: PropTypes.number,
        lng: PropTypes.number,
        anchor: PropTypes.shape({
          x: PropTypes.number,
          y: PropTypes.number,
        }),
        angle: PropTypes.number,
        opacity: PropTypes.number,
      }),
    ),
  })),
};

export default PxMapMarkersOverlay;
